/* ROME v5 – cart drawer, quick add, print-position toggle, local-currency texts, email popup */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cur = (window.Shopify && Shopify.currency) || { active: 'EUR', rate: '1.0' };
  var rate = parseFloat(cur.rate) || 1;
  var lang = document.documentElement.lang || 'en';
  var FREE_EUR = 50;

  function fmt(amount, decimals) {
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: cur.active, minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(amount);
    } catch (e) { return amount.toFixed(decimals) + ' ' + cur.active; }
  }

  /* ---------- Euro amounts in theme texts -> visitor currency ---------- */
  function localiseText(root) {
    if (cur.active === 'EUR') return;
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) { if (/€\s?\d/.test(walker.currentNode.nodeValue)) nodes.push(walker.currentNode); }
    nodes.forEach(function (n) {
      if (n.parentNode && /^(SCRIPT|STYLE|TEXTAREA)$/.test(n.parentNode.nodeName)) return;
      n.nodeValue = n.nodeValue.replace(/€\s?(\d+(?:[.,]\d{1,2})?)/g, function (m, v) {
        var eur = parseFloat(v.replace(',', '.'));
        var whole = Math.round(eur) === eur;
        var conv = eur * rate;
        return whole ? fmt(Math.ceil(conv), 0) : fmt(conv, 2);
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawerSel = '[data-cart-drawer]';
  function openDrawer() {
    var d = $(drawerSel); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('no-scroll');
  }
  function closeDrawer() {
    var d = $(drawerSel); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('no-scroll');
  }
  function updateFreeShip() {
    var box = $('[data-free-ship]'); if (!box) return;
    var total = parseInt(box.getAttribute('data-total'), 10) / 100;
    var goal = FREE_EUR * rate;
    var left = goal - total;
    var txt = $('[data-free-ship-text]', box), bar = $('[data-free-ship-bar]', box);
    if (left <= 0) { txt.innerHTML = '<strong>Free shipping unlocked</strong>'; bar.style.width = '100%'; }
    else { txt.innerHTML = 'Add <strong>' + fmt(left, 2) + '</strong> for free shipping'; bar.style.width = Math.max(4, Math.round(total / goal * 100)) + '%'; }
  }
  function renderDrawer(html, open) {
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = $(drawerSel, tmp), old = $(drawerSel);
    if (fresh && old) {
      var wasOpen = old.classList.contains('is-open') || open;
      old.parentNode.replaceChild(fresh, old);
      if (wasOpen) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden', 'false'); }
    }
    updateFreeShip(); localiseText($(drawerSel)); bindDrawer(); updateCounts();
  }
  function refresh(open) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) { renderDrawer(j['cart-drawer'], open); });
  }
  function updateCounts() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      $$('.cart-count').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
      var hdr = $('[data-cart-icon]');
      if (hdr && c.item_count > 0 && !$('.cart-count', hdr)) { var s = document.createElement('span'); s.className = 'cart-count'; s.textContent = c.item_count; hdr.appendChild(s); }
      var bar = $('[data-bundle-bar]'), bt = $('[data-bundle-text]');
      if (bar) bar.style.width = Math.min(100, Math.round(c.item_count / 3 * 100)) + '%';
      if (bt) bt.textContent = c.item_count >= 3 ? '10% off unlocked – applied automatically at checkout.' : (3 - c.item_count) + ' more ' + (c.item_count === 2 ? 'item' : 'items') + ' to unlock 10% off – applied automatically.';
    });
  }
  function addItem(id, qty, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute('data-busy', ''); }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return refresh(true); })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('data-busy'); } });
  }
  function bindDrawer() {
    $$('[data-cart-close]').forEach(function (b) { b.onclick = closeDrawer; });
    $$('[data-cart-drawer] [data-line]').forEach(function (b) {
      b.onclick = function () {
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(b.getAttribute('data-line')), quantity: Number(b.getAttribute('data-qty')) }) })
          .then(function () { return refresh(true); });
      };
    });
    bindQuickAdd($(drawerSel));
  }
  function bindQuickAdd(root) {
    $$('[data-quick-add]', root).forEach(function (f) {
      if (f._bound) return; f._bound = true;
      f.addEventListener('submit', function (e) { e.preventDefault(); addItem(f.elements.id.value, 1, $('button', f)); });
    });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  $$('[data-cart-icon]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); }); });

  /* Product form -> AJAX add + drawer (rome.js still handles size selection & validation) */
  var form = $('[data-product-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      var id = form.querySelector('[data-variant-id]').value;
      if (!id || e.defaultPrevented) return;
      e.preventDefault();
      addItem(id, 1, form.querySelector('[data-atc]'));
    });
  }

  /* ---------- Print position toggle (front / back product pair) ---------- */
  var toggle = $('[data-print-toggle]');
  if (toggle) {
    var vars = {};
    $$('[data-print-variants]', toggle).forEach(function (s) { try { vars[s.getAttribute('data-print-variants')] = JSON.parse(s.textContent); } catch (e) {} });
    $$('[data-print-link]', toggle).forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (a.classList.contains('is-selected')) { e.preventDefault(); return; }
        var target = vars[a.getAttribute('data-print-link')] || [];
        var chosen = [];
        $$('[data-choices]').forEach(function (g) { var s = g.querySelector('.is-selected'); chosen[+g.getAttribute('data-opt-index') || 0] = s ? s.getAttribute('data-value') : null; });
        var best = null;
        target.forEach(function (v) {
          var score = 0;
          v.options.forEach(function (o, i) { if (chosen[i] && chosen[i] === o) score++; });
          if (!best || score > best.score) best = { v: v, score: score };
        });
        if (best && best.score > 0) { e.preventDefault(); window.location.href = a.getAttribute('href') + '?variant=' + best.v.id; }
      });
    });
  }

  /* Shirt pictograms follow the chosen colour */
  function paintShirts() {
    var t = $('[data-print-toggle]'); if (!t) return;
    var sel = $('[data-kind="color"] .is-selected');
    var c = sel ? (sel.getAttribute('data-value') || '').toLowerCase() : 'white';
    t.setAttribute('data-shirt', /black|dark|navy|charcoal/.test(c) ? 'dark' : 'light');
  }
  $$('[data-kind="color"] [data-value]').forEach(function (b) { b.addEventListener('click', paintShirts); });
  paintShirts();

  /* ---------- Email popup (10% first order) ---------- */
  var pop = $('[data-popup]');
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  if (pop && !store('rw_popup') && !/\/(cart|checkout|pages\/(withdrawal|legal|privacy|terms))/.test(location.pathname)) {
    var shown = false;
    var show = function () { if (shown) return; shown = true; pop.hidden = false; store('rw_popup', String(Date.now())); };
    setTimeout(show, 15000);
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 10) show(); });
  }
  $$('[data-popup-close]').forEach(function (b) { b.addEventListener('click', function () { pop.hidden = true; }); });
  var pf = $('[data-popup-form]');
  if (pf) {
    pf.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = pf.querySelector('button'); btn.disabled = true;
      fetch('/contact', { method: 'POST', body: new FormData(pf) }).finally(function () {
        pf.hidden = true; $('[data-popup-done]').hidden = false;
      });
    });
  }

  /* init */
  updateFreeShip();
  localiseText(document.body);
  bindDrawer();
  bindQuickAdd(document);
})();
